import { WithSkeleton } from '@capsicum/common';
import styled from 'styled-components';

import { Skeleton, SkeletonItem } from '../../../atoms';

type ConversionRatesProps = {
	altCurrencyAmount?: string;
	defaultCurrencyAmount?: string;
};

const SkeletonContainer = () => {
	return (
		<Skeleton>
			<SkeletonItem height={16} width={80} />
			<SkeletonItem height={16} width={60} />
		</Skeleton>
	);
};

const AmountInputs = ({ altCurrencyAmount, defaultCurrencyAmount }: ConversionRatesProps) => {
	return (
		<>
			<S.AmountText>{defaultCurrencyAmount}</S.AmountText>
			{altCurrencyAmount && <S.AmountText>{altCurrencyAmount}</S.AmountText>}
		</>
	);
};

export const ConversionRates = WithSkeleton(AmountInputs, SkeletonContainer);

namespace S {
	export const AmountText = styled.div`
		${({ theme }) => theme.fonts.text.text5};
	`;
}
